import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit';

import { DefaultPathEnum } from '../../../../main/constants/default-path.ts';
import { ThunkApiConfigType } from '../../../../main/store/main.store.ts';
import { getUrlUtil } from '../../../../main/utils/url.util.ts';

import { fetchChildProfilesQueryRequest } from '../../../requests/fetch-child-profiles.query.ts';

import { ACCOUNTS_SLICE_NAME, AccountsSliceState, Profile } from '../accounts.slice.types.ts';

import { prefillChildProfileFormThunk } from './prefill-child-profile-form.thunk.ts';

interface ReturnType {
  data: Profile[];
}

export const fetchAndAssignChildProfileThunk = createAsyncThunk<ReturnType, void, ThunkApiConfigType>(
  `${ACCOUNTS_SLICE_NAME}/fetchAndAssignChildProfile`,
  async (_, thunkAPI) => {
    const result = await fetchChildProfilesQueryRequest();
    if (!result.success) {
      // TODO: Handle error
      // We should display an error message to the user and give the user a way to retry
      throw new Error(result.message);
    }

    if (result.data.length === 0) {
      await thunkAPI.dispatch(prefillChildProfileFormThunk()).unwrap();
    }

    return { data: result.data };
  }
);

export const fetchAndAssignChildProfileThunkExtraReducers = (
  builder: ActionReducerMapBuilder<AccountsSliceState>
): void => {
  builder.addCase(fetchAndAssignChildProfileThunk.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(fetchAndAssignChildProfileThunk.fulfilled, (state, action) => {
    state.isLoading = false;
    state.availableProfiles = action.payload.data;

    if (action.payload.data?.length === 0) {
      getUrlUtil().navigateToUrl(DefaultPathEnum.ACCOUNTS_CREATE_PROFILE, true);
      return;
    }
    state.currentProfile = action.payload.data?.[0];
  });

  builder.addCase(fetchAndAssignChildProfileThunk.rejected, (state) => {
    state.isLoading = false;
  });
};
